import { render } from "./TransitionWrapper.vue?vue&type=template&id=56c82c9a&scoped=true"
import script from "./TransitionWrapper.vue?vue&type=script&lang=js"
export * from "./TransitionWrapper.vue?vue&type=script&lang=js"

import "./TransitionWrapper.vue?vue&type=style&index=0&id=56c82c9a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c82c9a"]])

export default __exports__